<template>
	<div class="circle-template">
		<div class="circle-template-wrap">
			<div class="circle-template-header">
				<div class="circle-template-title">朋友圈模板选择</div>
				<div class="circle-template-h-opts">
					<span @click="close">关闭</span>
				</div>
			</div>
			<div class="circle-template-search">
				<input type="text" placeholder="模板标题" v-model="requestParams.title">
				<button @click="search">搜索</button>
			</div>
			<div class="circle-template-items">
				<div class="circle-template-item" :title="circle.title" v-for="circle in  circleList">
					<div class="circle-template-item-wrap">
						<div class="circle-template-i-title">{{circle.title}}</div>
						<div class="circle-template-i-text" v-if="circle.content != ''">
							{{circle.content}}
						</div>
						<div class="circle-template-i-pic" v-if="circle.type == 1">
							<img :src="img" alt="" v-for="img in circle.img_thumb">
						</div>
						<div class="circle-template-i-video" v-else-if="circle.type == 3">
							<img :src="circle.cover_thumb" alt="">
							<div class="circle-template-iv-play"></div>
						</div>
						<div class="circle-template-i-link" v-else-if="circle.type == 4">
							<div class="circle-template-il-img">
								<img :src="circle.img_thumb" alt="">
							</div>
							<div class="circle-template-il-text">
								<p>{{circle.url_content}}</p>
							</div>
						</div>
						<div class="circle-template-i-time">
							发布时间：{{circle.create_time}}
						</div>
					</div>	
					<div class="circle-template-item-select" @click="selectTemp(circle)"></div>
				</div>
			</div>
			<div class="circle-template-page">
				<page-component 
					:dataApi="dataApiFunction" 
					:requestParams = "requestParams"
					@page-call="pageCall($event)" 
					key="circle-template-page"
					ref="circleTemplatePage">
				</page-component>
			</div>
		</div>
	</div>
</template>

<script>
	import PageComponent from '../../components/PageComponent.vue'
	import {webGetFriendCircleList} from '../../network/web/friend-circle.js'
	
	export default{
		name:"CircleTemplate",
		components:{
			PageComponent
		},
		data(){
			return{
				dataApiFunction:webGetFriendCircleList,
				circleList:[],
				requestParams:{
					title: ''
				}
			}
		},
		methods:{
			// 监听分页数据回调
			pageCall(data){
				if(!data instanceof Array){
					return
				}
				for (let i = 0; i < data.length; i++) {
					if(data[i].type == 1){
						if(data[i].img_thumb === null || data[i].img_thumb === ""){
							if(data[i].img_url !== null && data[i].img_url !== ""){
								data[i].img_thumb = data[i].img_url.split(",")
							}else{
								data[i].img_thumb = []
							}
						}else{
							data[i].img_thumb = data[i].img_thumb.split(",")
						}
					}else if(data[i].type == 3){
						if(data[i].cover_thumb === null || data[i].cover_thumb === ""){
							data[i].cover_thumb = data[i].cover
						}
					}else if(data[i].type == 4){
						if(data[i].img_thumb === null || data[i].img_thumb === ""){
							data[i].img_thumb = data[i].img_url
						}
					}
				}
				this.circleList = data
			},
			
			// 搜索
			search(){
				this.$refs.circleTemplatePage.initPage()
			},
			
			// 关闭页面
			close(){
				this.$emit('close-circle-temp')
			},
			
			// 选择模板事件
			selectTemp(data){
				this.$emit("circle-temp-select",data)
			}
		}
	}
</script>

<style>
	.circle-template{
		position: relative;
		width: 100%;
		height: 100%;
		background-color: #FFFFFF;
		box-sizing: border-box;
		max-width: 1100px;
		margin: 0 auto;
	}
	.circle-template-wrap{
		position: relative;
		width: 100%;
		height: 100%;
	}
	.circle-template-wrap .circle-template-header{
		height: 44px;
		line-height: 44px;
		border-bottom: 1px solid #eaeaea;
		padding: 0 20px;
		display: flex;
		justify-content: space-between;
		background-color: #eeeeee;
	}
	.circle-template-header .circle-template-h-opts span{
		cursor: pointer;
		display: inline-block;
		height: 34px;
		line-height: 34px;
		padding: 5px;
		user-select: none;
	}
	.circle-template-wrap .circle-template-search{
		height: 30px;
		line-height: 30px;
		padding: 0 20px;
		margin-top: 6px;
		font-size: 13px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.circle-template-search input{
		border: 1px solid #dadada;
		height: 24px;
		padding: 0 5px;
		width: 120px;
		color: #6a6a6a;
	}
	.circle-template-search input:focus{
		border: 1px solid #42B983;
	}
	.circle-template-search button{
		height: 26px;
		padding: 0 10px;
		background-color: #42B983;
		margin-left: 5px;
		color: #FFFFFF;
		cursor: pointer;
		line-height: 26px;
	}
	.circle-template-wrap .circle-template-items{
		position: absolute;
		left: 0;
		right: 0;
		top: 84px;
		bottom: 142px;
		overflow-x: hidden;
		overflow-y: auto;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		align-content: flex-start;
		padding: 0 15px;
	}
	.circle-template-items .circle-template-item{
		width: 190px;
		height: 260px;
		margin: 5px;
		padding: 5px;
		overflow: hidden;
		box-shadow: 0 0 5px 0 #bebebe;
		border-radius: 2px;
		font-size: 12px;
		color: #787878;
		position: relative;
	}
	.circle-template-item .circle-template-item-wrap{
		position: relative;
		width: 205px;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.circle-template-item-wrap > *{
		width: 190px;
	}
	.circle-template-item-wrap .circle-template-i-title{
		font-size: 14px;
		font-weight: 600;
		height: 26px;
		line-height: 26px;
		overflow: hidden;
		color: #000000;
	}
	.circle-template-item-wrap .circle-template-i-text{
		line-height: 20px;
		overflow: hidden;
	}
	.circle-template-item-wrap .circle-template-i-pic{
		margin-top: 5px;
	}
	.circle-template-i-pic > img{
		display: inline-block;
		width: 58px;
		height: 58px;
		margin: 2px;
	}
	.circle-template-item-wrap .circle-template-i-video{
		width: 160px;
		height: auto;
		margin-top: 5px;
		background-color: #000000;
		position: relative;
	}
	.circle-template-i-video > img{
		width: 100%;
		border: 1px solid #CCCCCC;
		box-sizing: border-box;
		min-height: 60px;
	}
	.circle-template-i-video .circle-template-iv-play{
		width: 26px;
		height: 26px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		background-image: url(/img/video_play.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 26px auto;
	}
	.circle-template-item-wrap .circle-template-i-link{
		margin-top: 5px;
		width: 180px;
		height: 40px;
		padding: 5px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		background-color: #e6e6e6;
	}
	.circle-template-i-link .circle-template-il-img{
		width: 40px;
		height: 40px;
		margin-right: 5px;
	}
	.circle-template-i-link img{
		width: 100%;
		height: 100%;
		border-radius: 2px;
	}
	.circle-template-i-link .circle-template-il-text{
		width: 0;
		flex-grow: 1;
		max-height: 40px;
		overflow: hidden;
		line-height: 20px;
	}
	.circle-template-item-wrap .circle-template-i-time{
		height: 26px;
		line-height: 26px;
	}
	.circle-template-item .circle-template-item-select{
		position: absolute;
		top: 3px;
		right: 3px;
		width: 22px;
		height: 22px;
		background-color: #FFFFFF;
		background-image: url(../../assets/img/select-out.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 20px auto;
		cursor: pointer;
	}
	.circle-template-wrap .circle-template-page{
		position: absolute;
		width: 100%;
		height: 26px;
		bottom: 20px;
		left: 0;
	}
</style>
